<template>
  <div>
    <div v-if="session == null">
      <submission-spinner></submission-spinner>
    </div>
    <div v-else-if="session.watchStatus === 'IDLE'">
      <preview-session-page :session="session" />
    </div>
    <div v-else-if="session.watchStatus === 'LIVE'">
      <live-session-page :session="session" />
    </div>
    <div v-else-if="session.watchStatus === 'COMPLETE'">
      <previous-session-page :session="session" />
    </div>
  </div>
</template>

<script>
import LiveSessionPage from "../components/LiveSessionPage";
import PreviewSessionPage from "../components/PreviewSessionPage";
import PreviousSessionPage from "../components/PreviousSessionPage";
import { sanityClient } from "../utils/sanity";
import SubmissionSpinner from "../components/SubmissionSpinner";
export default {
  name: "Session",
  components: {
    SubmissionSpinner,
    PreviewSessionPage,
    PreviousSessionPage,
    LiveSessionPage
  },
  data() {
    return {
      session: null,
      subscription: null
    };
  },
  created() {
    this.fetchSession();
    // this.subscription = this.subscribe();
  },
  mounted: function() {
    this.pollData()
  },
  beforeDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.polling) {
      console.log("unsubscribe")
      clearInterval(this.polling)
    }
  },
  methods: {
    pollData() {
      this.polling = setInterval(() => {
        this.fetchSession();
      }, 360000);
    },
    fetchSession() {
      console.log("fetch");
      const slug = this.$route.params.slug;
      const queryString =
        "*[_type == 'session' && slug.current == $slug][0]{speakers[]->{...}, tutorials[]->{...}, productCompatibility[]->{...}, ...}";

      sanityClient
        .fetch(queryString, { slug })
        .then(res => {
          this.session = res;
        })
        .catch(err => {
          console.error(err);
        });
    }
  }
};
</script>
